import type { UISlotType } from "@/lib/plannedRouteMapping"
import type {
  DayOfWeek,
  PlannedRoute,
  PlannedStop,
  RouteCategory,
  RouteKind,
} from "@/types/collections"

/** Dragged stops snap to this many minutes. */
export const SNAP_INTERVAL = 15
/** Longer than this is almost certainly a mistyped time, so refused. */
export const MAX_STOP_DURATION_HOURS = 18

export type DragType = "move" | "resize-left" | "resize-right"

export interface DragState {
  routeId: string
  stopId: string
  type: DragType
  startX: number
  originalStop: PlannedStop
  originalStops: PlannedStop[]
}

export interface DragCreateState {
  rowIndex: number
  startX: number
  currentX: number
  startTime: Date
  endTime: Date
}

export interface PendingStopData {
  routeId: string
  startTime: Date
  endTime: Date
}

export interface NewStopFormData {
  locationId: string
  startTime: string // HH:mm format
  endTime: string // HH:mm format
  slotType: UISlotType
  slotService: string[] // Multi-select: SD, ND, 2D
  slotPnl: string[] // Multi-select: RC1, RC2, Hived One, Haulage
  /** Revenue in GBP for Haulage Delivery stops (optional). */
  haulageDeliveryRevenueGbp?: number | null
  /** Agreed price in GBP for Direct Injection stops (optional). */
  directInjectionCostGbp?: number | null
}

export interface RouteFormData {
  name: string
  category: RouteCategory
  operator: string
  vehicleType: string
  /** Drivers the route is run with. 2 is double-manned: one truck, two people. */
  crewSize: number
  routeKind: RouteKind
  status: "draft" | "live" | "cancelled"
  isRecurring: boolean
  recurringDays: DayOfWeek[]
  effectiveFromDate: Date | undefined
  effectiveToDate: Date | undefined
  excludedDates: Date[]
  /** HH:mm, parsed against the selected date to derive a duration. */
  startTime: string
  endTime: string
}

export type EditableRoute = PlannedRoute & { effectiveFromDate?: Date }

/** A route being edited as one day's instance rather than as its plan. */
export type InstanceEditMode = { routeId: string; date: Date } | null
